var _rect, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRsaCal(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 152,
    height: 152,
    viewBox: "0 0 152 152",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 151.844,
    height: 151.844,
    rx: 75.922,
    fill: "#EFF8F3"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_3883_5962)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M102.661 108.11H100.216C99.4716 108.11 98.8869 107.525 98.8869 106.781C98.8869 106.037 99.4716 105.452 100.216 105.452H102.661C104.336 105.452 105.691 104.096 105.691 102.422V56.0669C105.691 54.3924 104.336 53.0369 102.661 53.0369H49.688C48.0135 53.0369 46.658 54.3924 46.658 56.0669V102.422C46.658 104.096 48.0135 105.452 49.688 105.452H95.2986C96.0429 105.452 96.6276 106.037 96.6276 106.781C96.6276 107.525 96.0429 108.11 95.2986 108.11H49.688C46.5516 108.11 44 105.558 44 102.422V56.0669C44 52.9305 46.5516 50.3789 49.688 50.3789H102.661C105.798 50.3789 108.349 52.9305 108.349 56.0669V102.422C108.376 105.558 105.798 108.11 102.661 108.11Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M92.2157 57.5822C91.4715 57.5822 90.8867 56.9974 90.8867 56.2532V45.329C90.8867 44.5848 91.4715 44 92.2157 44C92.9599 44 93.5447 44.5848 93.5447 45.329V56.2532C93.5447 56.9708 92.9599 57.5822 92.2157 57.5822Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60.7704 57.5822C60.0262 57.5822 59.4414 56.9974 59.4414 56.2532V45.329C59.4414 44.5848 60.0262 44 60.7704 44C61.5146 44 62.0994 44.5848 62.0994 45.329V56.2532C62.0994 56.9708 61.5146 57.5822 60.7704 57.5822Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M107.047 66.8064H45.329C44.5848 66.8064 44 66.2216 44 65.4774C44 64.7332 44.5848 64.1484 45.329 64.1484H107.047C107.791 64.1484 108.376 64.7332 108.376 65.4774C108.376 66.2216 107.764 66.8064 107.047 66.8064Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M63.1356 83.1518H55.8794C55.4276 83.1518 55.082 82.7797 55.082 82.3544V75.0982C55.082 74.6463 55.4541 74.3008 55.8794 74.3008H63.1356C63.5875 74.3008 63.933 74.6729 63.933 75.0982V82.3544C63.933 82.7797 63.5875 83.1518 63.1356 83.1518Z",
    fill: "#05D484"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M63.1356 98.0112H55.8794C55.4276 98.0112 55.082 97.6391 55.082 97.2138V89.9575C55.082 89.5057 55.4541 89.1602 55.8794 89.1602H63.1356C63.5875 89.1602 63.933 89.5323 63.933 89.9575V97.2138C63.933 97.6656 63.5875 98.0112 63.1356 98.0112Z",
    fill: "#05D484"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M79.8271 83.1518H72.5708C72.119 83.1518 71.7734 82.7797 71.7734 82.3544V75.0982C71.7734 74.6463 72.1456 74.3008 72.5708 74.3008H79.8271C80.2789 74.3008 80.6244 74.6729 80.6244 75.0982V82.3544C80.6244 82.7797 80.2523 83.1518 79.8271 83.1518Z",
    fill: "#05D484"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M79.8271 98.0112H72.5708C72.119 98.0112 71.7734 97.6391 71.7734 97.2138V89.9575C71.7734 89.5057 72.1456 89.1602 72.5708 89.1602H79.8271C80.2789 89.1602 80.6244 89.5323 80.6244 89.9575V97.2138C80.6244 97.6656 80.2523 98.0112 79.8271 98.0112Z",
    fill: "#05D484"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M96.4911 83.1518H89.2349C88.783 83.1518 88.4375 82.7797 88.4375 82.3544V75.0982C88.4375 74.6463 88.8096 74.3008 89.2349 74.3008H96.4911C96.943 74.3008 97.2885 74.6729 97.2885 75.0982V82.3544C97.2885 82.7797 96.943 83.1518 96.4911 83.1518Z",
    fill: "#05D484"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3883_5962"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 64.3758,
    height: 64.11,
    fill: "white",
    transform: "translate(44 44)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRsaCal);
export default __webpack_public_path__ + "static/media/RsaCal.d6f89917.svg";
export { ForwardRef as ReactComponent };